module.exports = __webpack_public_path__ + "img/logo1.dc060c44.png";